//hooks what's define in query params ?dev=true
import {useEffect} from "react";
import {AppStore} from "../useAppPullState";

export const useIsDev = () => {
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const isDev = params.get('dev') === 'true';
        AppStore.update(s => {
            s.isDev = isDev;
        })
    },[])

}
